import { configureStore } from "@reduxjs/toolkit";
import globalReducer from '../API Services/redux/globalSlice';
import employeeGraphApi from "../API Services/GraphAPIs/employeeDetailsGraphAPIs";
import locationsGraphAPI from "../API Services/GraphAPIs/locationAPIs";
import companyDetailsGraphAPI from "../API Services/GraphAPIs/companyDetailsAPIs";
const store = configureStore({
  reducer: {
    global: globalReducer,
    employeeGraphApi: employeeGraphApi.reducer,
    locationsGraphAPI: locationsGraphAPI.reducer,
    companyDetailsGraphAPI: companyDetailsGraphAPI.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      employeeGraphApi.middleware,
      locationsGraphAPI.middleware,
      companyDetailsGraphAPI.middleware
    ),
});

export type RootState = ReturnType<typeof store.getState>;

export default store;
